import { RepaymentExitByType } from './RepaymentExitByType';

export const RepaymentExitByTypeOptions = [
    {
        id: RepaymentExitByType.Sale,
        name: 'Sale',
    },
    {
        id: RepaymentExitByType.Refinance,
        name: 'Refinance',
    },
    {
        id: RepaymentExitByType.Other,
        name: 'Other',
    },
    {
        id: RepaymentExitByType.Unknown,
        name: 'Unknown',
    },
];
